import { fromJS } from 'immutable'
import { handleActions } from 'redux-actions'
import ActionHelper from 'helpers/action'

// constants
export const UPLOAD_FILES = 'files/UPLOAD_FILES'
export const REMOVE_FILES = 'files/REMOVE_FILES'

// actions
export const uploadFiles = ActionHelper.createActionObj(UPLOAD_FILES)
export const removeFiles = ActionHelper.createActionObj(REMOVE_FILES)

// state
const initState = () => fromJS({})
// reducer
const files = handleActions({}, initState())

export default files
